// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1199":"2197f93c","8152":"2197f93c"}[chunkId] + ".chunk.css";
};